export const formatCurrency = (n: number | null | undefined) =>
  `$${(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`

export const formatPercent = (n: number | null | undefined) =>
  `${(n || 0).toFixed(1)}%`